<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import { Track } from '$lib/models/track';
  import { player } from '$lib/stores/player';
  import Spinner from './spinner.svelte';
  import playIcon from '$lib/assets/shared/play/play-grey.svg';
  import playIconWhite from '$lib/assets/shared/play/play-white-no-background.svg';
  import pauseIcon from '$lib/assets/shared/play/pause-pink.svg';
  import pauseIconWhite from '$lib/assets/shared/play/pause-white-no-background.svg';
  import { translation } from '$lib/locale/locale';
  import { srcset } from '$lib/utils/srcset';
  import { get } from 'svelte/store';
  const {} = translation();

  const { track }: { track: Track } = $props();

  let playing = $state(false);
  let loadingAudio = $state(false);
  let isActive = false;
  let progress = 0;

  $effect(() => {
    isActive = $player.id === track.id;
    if (isActive) {
      progress = $player.progress;
      playing = $player.status === 'playing';
      loadingAudio = $player.status === 'loading';
    } else {
      progress = 0;
      playing = false;
      loadingAudio = false;
    }
  });
</script>

<div class="button-wrap" class:with-cover={track.srcset?.length}>
  {#if loadingAudio}
    <div class="spinner">
      <Spinner size="28px" slim={true} />
    </div>
  {:else if playing}
    <button class="play" class:play-sfx={!track.srcset?.length} onclick={() => player.pause()}>
      {#if track.srcset?.length}
        <img src={pauseIconWhite} alt={m['actions.pause']()} loading="lazy" />
      {:else}
        <img src={pauseIcon} alt={m['actions.pause']()} loading="lazy" />
      {/if}
    </button>
  {:else}
    <button
      class="play reveal"
      class:with-cover={track.srcset?.length}
      class:play-sfx={!track.srcset?.length}
      onclick={() => (isActive ? player.resume() : player.play(track))}
    >
      {#if track.srcset?.length}
        <img src={playIconWhite} alt={m['actions.play']()} loading="lazy" />
      {:else}
        <img src={playIcon} alt={m['actions.play']()} loading="lazy" />
      {/if}
    </button>
  {/if}
  {#if track.srcset?.length}
    <img class="cover" srcset={srcset(track.srcset)} aria-hidden="true" alt="" sizes="(max-width: 620px) 44px, 48px" loading="lazy" />
  {/if}
</div>

<style>
  .button-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 36px;
    height: 36px;
  }

  .button-wrap.with-cover {
    width: 48px;
    height: 48px;
  }

  .button-wrap.with-cover .play {
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .button-wrap.with-cover .cover {
    flex-shrink: 0;
    object-fit: contain;
    border-radius: 8px;
    background-color: var(--gainsboro);
    aspect-ratio: 1;
  }

  .button-wrap.with-cover .reveal {
    opacity: 0;
    transition: opacity 0.2s;
  }

  .button-wrap.with-cover .reveal:hover {
    opacity: 1;
    width: 48px;
    height: 48px;
  }

  .button-wrap .play {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .button-wrap .play img {
    width: 20px;
    height: 20px;
  }

  .button-wrap .spinner {
    position: absolute;
    display: flex;
  }

  .button-wrap .play-sfx img {
    width: 27px;
    height: 27px;
  }
</style>
